module.exports = __webpack_public_path__ + "static/media/juci.23e31c81.png";